function hideSocialsSubscribeBlock() {
    const expireDate = 365;
    setCookie('isSocialsSubscribeVisible', false, { 'expires' : expireDate, 'path' : '/', 'encode': true });
    document.querySelector('.socials-subscribe').classList.remove('visible');
    document.querySelector('.socials-subscribe').classList.add('hide');
    removeCloseListeners();
}

function initSocialsSubscribeBlock() {
    const hasCookie = getCookie('isSocialsSubscribeVisible');
    if (!hasCookie) {
        document.querySelector('.socials-subscribe').classList.add('visible');
        setCloseListeners();
    }
}

function setCloseListeners() {
    const closeBtns = document.querySelectorAll('.js-socials-subscribe');
    closeBtns.forEach(btn => {
        btn.addEventListener('click', hideSocialsSubscribeBlock);
    });
}

function removeCloseListeners() {
    const closeBtns = document.querySelectorAll('.js-socials-subscribe');
    closeBtns.forEach(btn => {
        btn.removeEventListener('click', hideSocialsSubscribeBlock);
    });
}

initSocialsSubscribeBlock();
